
import TextInput from 'components/inputs/TextInput/TextInput';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useHttp from 'utils/hooks/useHttp';

import Spinner from 'components/spinner/Spinner';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { notify } from 'utils/marketplace';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import UploadImage from 'components/UploadImage/UploadImage';
import { INonTecdocPartSupplier, ISupplierValidate } from 'interfaces/nonTecdocCatalog';
import './SupplierEdit.scss';


type Props = {
  setOpenModal: (e: boolean) => void;
  setSubmit: (e: boolean) => void;
  id: number | undefined
};


const SupplierEdit: React.FC<Props> = (props) => {
  let isMounted = true;
  const { t } = useTranslation();
  const http = useHttp();
  const [file, setFile] = useState<File[]>([]);
  const [supplierInfo, setSupplierInfo] = useState<INonTecdocPartSupplier>();
  const [loading, setLoading] = useState<boolean>(false);

  const validate = Yup.object().shape({

    name: Yup.string().trim().required(t('_fild_required')),
  });

  const { getValues, register, handleSubmit, formState: { errors } } = useForm<ISupplierValidate>({ resolver: yupResolver(validate) });

  useEffect(() => {
    if (props.id && isMounted) {
      http.nonTecDocCatalog.getNonTecdocSupplierById(props.id)
        .then((res) => {
          setSupplierInfo(res.data);
        });
    }

    return () => {
      isMounted = false;
    };
  }, []);


  const onSubmit = async () => {
    setLoading(true);
    const values = getValues();
    const formData: FormData = new FormData();

    formData.append('name', values.name.trim());
    formData.append('client_erp_id', String(values?.client_erp_id));

    if (file.length) {
      formData.append('image', file[0]);
    }

    http.nonTecDocCatalog.editSupplier(Number(props?.id), formData).then(() => {
      notify(t('_non_tecdoc_supplier_updated'), 'success', t('_success'));
      props.setOpenModal(false);
      props.setSubmit(true);
    }).catch((error) => {
      let erorrs = '';

      Object.entries(error).forEach(([key, value]) => {
        erorrs += `${t('_' + key)} : ${value} `;
      });
      notify(erorrs, 'error', t('_error'));
      setLoading(false);
    });
  };


  return (
    <div className="non_tecdoc_supplier-edit-container" >
      <div className="close-modal" onClick={() => { props.setOpenModal(false); }}><FontAwesomeIcon icon={faClose} /></div>

      <div className="title">
        {t('_battery_title_edit')}
        <br />
        <span>{t('_non_tecdoc_supplier_title_edit')}</span>
      </div>

      {
        !supplierInfo ?
          <div className="spinner-info">
            <Spinner />
          </div>
          :
          <React.Fragment >
            <div className="info-item">
              {t('_battery_item_count')}
              <br />
              <span>{supplierInfo?.name}</span>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div>
                <div className="row">
                  <div className={`container ${errors.name?.type == 'required' ? 'error' : ''}`}>
                    <label>
                      {t('_name')}
                    </label>
                    <TextInput defaultValue={supplierInfo?.name} {...register('name')} />
                    <p className="error-message">{errors.name?.type == 'required' ? errors.name?.message : ''}</p>
                  </div>
                  <div className="container">
                    <label>
                      {t('_client_erp_id')}
                    </label>
                    <TextInput defaultValue={supplierInfo?.client_erp_id} {...register('client_erp_id')} />
                  </div>
                </div>
                <div className="row">
                  <div className="container">
                    <UploadImage errors={errors} setFile={setFile} image={supplierInfo?.image} />
                  </div>
                </div>
              </div>
              <div className="btn-save">
                <button type="submit" className={loading ? 'disabled' : ''}> {loading ? <Spinner class="extra-small" /> : null} <div className="title-btn-save">{t('_save')}</div></button>
              </div>
            </form>
          </React.Fragment>
      }
    </div>
  );
};

export default SupplierEdit; 